import './index.scss';
import React, { useState } from 'react';
import Button from '~/components/button';
import Input from '~/components/input';
import Modal from '~/components/modal';
const Example = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const hideModal = () => setModalVisible(false);
    const showModal = () => setModalVisible(true);
    return (React.createElement("div", { className: 'example-page' },
        React.createElement("h1", null, "Example Components"),
        React.createElement("h3", { className: 'ex-h3' }, "Typography"),
        React.createElement("h4", null, "Paragraph"),
        React.createElement("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non lorem tristique, auctor mauris at, dignissim nisi. Aenean vehicula leo in sagittis vulputate. Curabitur hendrerit enim ante, id venenatis dui malesuada in. Duis fermentum lobortis dolor sed luctus. Nulla in nisi at ligula volutpat malesuada ut a turpis. Aenean pulvinar nisi ante, ut condimentum nisi semper et. Proin consectetur ipsum eu finibus faucibus. Nam ac massa sit amet tortor sagittis pharetra. Suspendisse eget odio mauris. Integer euismod id odio sed facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        React.createElement("h1", null, "H1"),
        React.createElement("h2", null, "H2"),
        React.createElement("h3", null, "H3"),
        React.createElement("h4", null, "H4"),
        React.createElement("h5", null, "H5"),
        React.createElement("h6", null, "H6"),
        React.createElement("h3", { className: 'ex-h3' }, "Lists"),
        React.createElement("ul", null,
            React.createElement("li", null, "Unordered Item 1"),
            React.createElement("li", null, "Unordered Item 2"),
            React.createElement("li", null, "Item 3")),
        React.createElement("ol", null,
            React.createElement("li", null, "Ordered List Item 1"),
            React.createElement("li", null, "Ordered List Item 2"),
            React.createElement("li", null, "Ordered List Item 3")),
        React.createElement("dl", null,
            React.createElement("dt", null, "Description List Title"),
            React.createElement("dd", null, "Description List content")),
        React.createElement("h3", { className: 'ex-h3' }, "Primary Buttons"),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, null, "Button"),
            React.createElement("code", null, '<Button>Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { primary: true }, "Primary Button"),
            React.createElement("code", null, '<Button primary>Primary Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { primary: true, disabled: true }, "Primary Disabled Button"),
            React.createElement("code", null, '<Button primary disabled>Primary Disabled Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { primary: true, outline: true }, "Outline Button"),
            React.createElement("code", null, '<Button primary outline>Outline Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { primary: true, outline: true, disabled: true }, "Outline Disabled Button"),
            React.createElement("code", null, '<Button primary outline disabled>Outline Disabled Button</Button>')),
        React.createElement("h3", { className: 'ex-h3' }, "Secondary Buttons"),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { secondary: true }, "Secondary Button"),
            React.createElement("code", null, '<Button secondary>Secondary Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { secondary: true, disabled: true }, "Secondary Disabled Button"),
            React.createElement("code", null, '<Button secondary disabled>Secondary Disabled Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { secondary: true, outline: true }, "Secondary Outline Button"),
            React.createElement("code", null, '<Button secondary outline>Secondary Outline Button</Button>')),
        React.createElement("div", { className: 'example' },
            React.createElement(Button, { secondary: true, outline: true, disabled: true }, "Secondary Outline Disabled Button"),
            React.createElement("code", null, '<Button secondary outline disabled>Secondary Outline Button</Button>')),
        React.createElement("h3", { className: 'ex-h3' }, "Shadows"),
        React.createElement("div", { className: 'example-shadow small-shadow' }, "Small Shadow"),
        React.createElement("div", { className: 'example-shadow medium-shadow' }, "Medium Shadow"),
        React.createElement("div", { className: 'example-shadow large-shadow' }, "Large Shadow"),
        React.createElement("h3", { className: 'ex-h3' }, "Inputs"),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, null),
            React.createElement("code", null, '<Input />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { lefticon: React.createElement("span", { className: 'fas fa-search' }), righticon: React.createElement("span", { className: 'fas fa-search' }), placeholder: 'Placeholder' }),
            React.createElement("code", null, '<Input lefticon=\'\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { lefticon: React.createElement("span", { className: 'fas fa-search' }), righticon: React.createElement("span", { className: 'fas fa-question-circle' }), value: 'Text here' }),
            React.createElement("code", null, '<Input lefticon=\'\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { success: true }),
            React.createElement("code", null, '<Input success />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { error: true }),
            React.createElement("code", null, '<Input error />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { placeholder: 'Placeholder' }),
            React.createElement("code", null, '<Input placeholder=\'Placeholder\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { defaultValue: 'Active' }),
            React.createElement("code", null, '<Input defaultValue=\'Active\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'textarea', rows: 2 }),
            React.createElement("code", null, '<Input type=\'textarea\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'textarea', rows: 2, placeholder: 'Placeholder' }),
            React.createElement("code", null, '<Input type=\'textarea\' placeholder=\'Placeholder\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'textarea', rows: 2, defaultValue: 'Active' }),
            React.createElement("code", null, '<Input type=\'textarea\' defaultValue=\'Active\' />')),
        React.createElement("p", null, "*Note: Select options will always have an empty selectable value in them."),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'select', placeholder: 'Select Option' },
                React.createElement("option", { value: 'select-me' }, "Select me")),
            React.createElement("code", null, "<Input type='select' placeholder='Select Option'><option value='select-me'>Select me</option></Input>")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'select' },
                React.createElement("option", { value: 'select-me' }, "Select me")),
            React.createElement("code", null, '<Input type=\'select\'><option value="select-me">Select me</option></Input>')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'radio', id: 'my-radio', label: 'Default Radio' }),
            React.createElement("code", null, '<Input type=\'radio\' id=\'my-radio\' label=\'Default Radio\' />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'radio', id: 'error-radio', label: 'Default Radio Error', error: true }),
            React.createElement("code", null, "<Input type='radio' id='error-radio' label='Default Radio Error' error />")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'radio', id: 'checked-radio', label: 'Checked Radio', checked: true }),
            React.createElement("code", null, "<Input type='radio' id='checked-radio' label='Checked Radio' checked />")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'radio', id: 'disabled-radio', label: 'Disabled Radio', disabled: true }),
            React.createElement("code", null, "<Input type='radio' id='disabled-radio' label='Disabled Radio' disabled />")),
        React.createElement("p", null, "*Note: Checkboxes require an ID to work properly."),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'checkbox', id: 'my-checkbox', label: 'Default Checkbox' }),
            React.createElement("code", null, "<Input type='checkbox' id='my-checkbox' label='Default Checkbox' />")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'checkbox', id: 'error-checkbox', label: 'Default Checkbox Error', error: true }),
            React.createElement("code", null, "<Input type='checkbox' id='error-checkbox' label='Default Checkbox Error' error />")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'checkbox', id: 'checked-checkbox', label: 'Checked Checkbox', checked: true }),
            React.createElement("code", null, "<Input type='checkbox' id='checked-checkbox' label='Checked Checkbox' checked />")),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { type: 'checkbox', id: 'disabled-checkbox', label: 'Disabled Checkbox', disabled: true }),
            React.createElement("code", null, '<Input type=\'checkbox\' id=\'my-checkbox\' label=\'Disabled Checkbox\' />')),
        React.createElement("h3", { className: 'ex-h3' }, "Input Sizes"),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { placeholder: 'Small Input Size', small: true }),
            React.createElement("code", null, '<Input placeholder=\'Small Input Size\' small />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { placeholder: 'Default Input Size' }),
            React.createElement("code", null, '<Input placeholder=\'Default Input Size\' small />')),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Input, { placeholder: 'Large Input Size', large: true }),
            React.createElement("code", null, '<Input placeholder=\'Large Input Size\' large />')),
        React.createElement("h3", { className: 'ex-h3' }, "Modal"),
        React.createElement("div", { className: 'example example-input' },
            React.createElement(Button, { onClick: () => showModal() }, "Click To See Example Modal"),
            React.createElement(Modal, { visible: modalVisible, onHide: hideModal },
                React.createElement("h1", null, "My Example Modal"),
                React.createElement("h3", null, "You can click close in the top right to close the modal."),
                React.createElement("h3", null, "You can click anywhere on the overlay to close the modal."),
                React.createElement("h3", null, "You can hit escape to close the modal."))),
        React.createElement("div", { className: 'example example-input' },
            React.createElement("pre", null,
                React.createElement("code", null, `
const [modalVisible, setModalVisible] = useState(false);
const hideModal = () => setModalVisible(false);
const showModal = () => setModalVisible(true);
          `)),
            React.createElement("pre", null,
                React.createElement("code", null, `
<Button onClick={() => showModal()}>Click To See Example Modal</Button>
        `)),
            React.createElement("pre", null,
                React.createElement("code", null, `
<Modal visible={modalVisible} onHide={hideModal}>
  <h1>My Example Modal</h1>
  <h3>You can click close in the top right to close the modal.</h3>
  <h3>You can click anywhere on the overlay to close the modal.</h3>
  <h3>You can hit escape to close the modal.</h3>
</Modal>

        `)))));
};
export default Example;
